import { Icon } from '@manychat/manyui'

import { TriggerType } from 'common/flow/constants/TriggerType'

export const HotmartAppId = 11
export const TikTokAdsAppId = 12

export const AppIdToIconMapping: Record<number, Icon.Icon> = {
  [HotmartAppId]: Icon.Hotmart,
  [TikTokAdsAppId]: Icon.TikTok,
}

export const CreateTriggerTypes = [
  TriggerType.KEYWORD,
  TriggerType.AI_INTENT,
  TriggerType.META_KEYWORD,
]
